var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgQuestion = function SvgQuestion(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "question",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_109",
    "data-name": "Trazado 109",
    d: "M18,34A16,16,0,1,1,34,18,16,16,0,0,1,18,34ZM18,2.914A15.086,15.086,0,1,0,33.086,18,15.086,15.086,0,0,0,18,2.914Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_110",
    "data-name": "Trazado 110",
    d: "M21.981,34.629A12.648,12.648,0,1,1,34.629,21.981,12.648,12.648,0,0,1,21.981,34.629Zm0-24.381A11.734,11.734,0,1,0,33.714,21.981,11.734,11.734,0,0,0,21.981,10.248Z",
    transform: "translate(-3.981 -3.981)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_111",
    "data-name": "Trazado 111",
    d: "M31.692,33.039a.457.457,0,0,1-.457-.457,4.895,4.895,0,0,1,2.357-4.109,3.531,3.531,0,0,0,1.653-3.109,3.6,3.6,0,0,0-3.452-3.452,3.555,3.555,0,0,0-3.657,3.553.457.457,0,0,1-.914,0A4.469,4.469,0,0,1,31.818,21a4.523,4.523,0,0,1,4.343,4.343,4.438,4.438,0,0,1-2.079,3.9,3.985,3.985,0,0,0-1.933,3.337A.457.457,0,0,1,31.692,33.039Z",
    transform: "translate(-13.692 -10.312)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_112",
    "data-name": "Trazado 112",
    d: "M36.457,51.292A.457.457,0,0,1,36,50.834V50.31a.457.457,0,0,1,.914,0v.524A.457.457,0,0,1,36.457,51.292Z",
    transform: "translate(-18.457 -25.977)"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuestion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/question.7e5cd05c.svg";
export { ForwardRef as ReactComponent };